export const PAYMENT_STEP_ROUTE = 'platnosc';
